import { render, staticRenderFns } from "./ProductoIndex.vue?vue&type=template&id=05e2a067"
import script from "./ProductoIndex.vue?vue&type=script&lang=js"
export * from "./ProductoIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports